import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";
import ms_button from '../../images/png/SingleSignOn.png'
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';

class LoginForm extends React.Component {
    state = {
        username: "",
        password: "",
        captcha: false,
        MS_SSO: process.env.REACT_APP_MICROSOFT_SSO,
        Recaptcha_Disabled: process.env.REACT_APP_DISABLE_RECAPTCHA
    }
    changeName = (event) => {
        this.setState({ username: event.target.value })
    }
    changePassword = (event) => {
        this.setState({ password: event.target.value })
    }
    handleSubmit = (event) => {
        event.preventDefault()
        if (this.state.captcha || this.state.Recaptcha_Disabled !== "false") {
            this.props.sendLogin(this.state.username, this.state.password)
        } else {
            this.props.showMessage("Please Enter Captcha Before Attempting to Sign In")
        }
    }
    handleCaptcha = () => {
        this.setState({ captcha: true })
    }
    handleMicrosoftLink = () => {
        return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${process.env.REACT_APP_MICROSOFT_SSO_CLIENT_ID}&response_type=code&response_mode=query&scope=openid%20email%20profile&redirect_uri=${process.env.REACT_APP_MICROSOFT_SSO_REDIRECT_URL}&state=007`
    }

    render() {
        return (
            <div className="loginBox">
                <div className="loginHead">
                    <h3>Login here</h3>
                    <span>
                        {this.state.MS_SSO === "true" ?
                            <a href={this.handleMicrosoftLink()}>
                                <img src={ms_button} alt="Sign in" />
                            </a>
                            : ""
                        }
                    </span>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <div className="inputOut">
                        <PersonIcon />

                        <input
                            type="text"
                            name="name"
                            placeholder="User.Name@email.com"
                            value={this.state.username}
                            onChange={this.changeName}
                            id="loginuser_txt"
                            onChangeCapture={(e) => this.setState({ username: e.target.value })}
                            className="myInput"
                        />
                        {/* {errors.Email && touched.Email && (
                            <Typography className="loginError">
                              {errors.Email}
                            </Typography>
                          )} */}
                    </div>
                    <div className="inputOut">
                        <LockIcon />
                        <input
                            type="Password"
                            name="Password"
                            onChange={this.changePassword} 
                            value={this.state.password} 
                            placeholder="UserPassword"
                            id="loginpass_txt"
                            onChangeCapture={(e) => this.setState({ password: e.target.value })}
                            className="myInput"
                        />
                        {/* {errors.Password && touched.Password && (
                            <Typography className="loginError">
                                {errors.Password}
                            </Typography>
                        )} */}
                    </div>
                    {this.state.Recaptcha_Disabled === "true" ? "" :
                        <ReCAPTCHA
                            sitekey="6LcW47EUAAAAAAghr3cvLBUQdAM5a5w2ZohoGOS2"
                            onChange={(e) => this.handleCaptcha()}
                        />
                    }
                    <button
                        type="submit"
                        className="btn"
                        onClick={(e) => this.handleSubmit(e)}
                    >Submit</button>
                </form>
            </div>
        )
    }
}

export default LoginForm